import { render, staticRenderFns } from "./RankTable.vue?vue&type=template&id=66ce52ca&scoped=true&"
import script from "./RankTable.vue?vue&type=script&lang=ts&"
export * from "./RankTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce52ca",
  null
  
)

export default component.exports